const rewardsData = [
    {
        id: 1,
        date: "Nov 23, 2023",
        rewardType: "Exploding Reward",
        cashbackPercent: .15,
        merchant: "Sephora",
        time: "01:28 PM",
        cardInfo: "VISA ****5676",
        amountSpent: 24.00,      
        img: require("../src/Assets/Member Patrick Starrr/Exploding Reward.png") 
    },

    {
        id: 2,
        date: "Nov 23, 2023",
        rewardType: "Repeat Reward",
        cashbackPercent: .20,
        merchant: "Bright Smile",
        time: "01:28 PM",
        cardInfo: "VISA ****5676",
        amountSpent: 35.00,
        img: require("../src/Assets/Member DJ Khaled/Reward Type-1.png")
               
    },

    {
        id: 3,
        date: "Nov 23, 2023",
        rewardType: "Expiring Reward",
        cashbackPercent: .25,
        merchant: "MAC",
        time: "01:28 PM",
        cardInfo: "VISA ****5676",
        amountSpent: 15.00,
        img: require("../src/Assets/Member Patrick Starrr/Expiring Reward.png")
               
    },

    {
        id: 4,
        date: "Nov 23, 2023",
        rewardType:  "Exploding Reward",
        cashbackPercent: .15,
        merchant: "Athletic Greens",
        time: "01:28 PM",
        cardInfo: "VISA ****5676",
        amountSpent: 18.00,
        img: require("../src/Assets/Member Patrick Starrr/Exploding Reward.png")          
    },

    {
        id: 5,
        date: "Nov 23, 2023",
        rewardType:  "Repeat Reward",
        cashbackPercent: .20,
        merchant: "Buffalo Wild Wings",
        time: "01:28 PM",
        cardInfo: "VISA ****5676",
        amountSpent: 40.0,
        img: require("../src/Assets/Member DJ Khaled/Reward Type-1.png")
               
    },

    {
        id: 6,
        date: "Nov 23, 2023",
        rewardType:  "Expiring Reward",
        cashbackPercent: .25,
        merchant: "Express VPN",
        time: "01:28 PM",
        cardInfo: "VISA ****5676", 
        amountSpent: 28.00,
        img: require("../src/Assets/Member Patrick Starrr/Expiring Reward.png")
               
    }
]

export default rewardsData; 